import React from 'react';

const OptimizedImage = ({ src, alt, className }) => {
  return (
    <img
      src={src || ''}
      alt={alt || ''}
      className={className}
      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
      loading="lazy"
    />
  );
};

export default OptimizedImage;
